import { Article, Client } from "types";

import { isSameImportValue } from "./index";

export const findClientByCode = (
  clients: Client[],
  clientCode: unknown,
) => clients.find((client) => isSameImportValue(client.code, clientCode));

export const getScopedClientIds = (clients: Client[], clientId: number) => [
  clientId,
  ...clients
    .filter((client) => client.parent_client_id === clientId)
    .map((client) => client.id),
];

export const findScopedArticleByClientId = (
  clients: Client[],
  articles: Article[],
  clientId: number,
  articleCode: unknown,
) => {
  const scopedClientIds = getScopedClientIds(clients, clientId);

  return articles.find(
    (article) =>
      scopedClientIds.includes(article.client_id) &&
      isSameImportValue(article.code, articleCode),
  );
};
